const camelCaseToSnakeCase = string => string.replace(/[A-Z]/g, char => `_${char.toLowerCase()}`).replace(/^_/, '');

export default camelCaseToSnakeCase;
